import { useQuery } from '@apollo/client';

import { useCommunityContext } from 'components/CommunityContext';

import { USERS_QUERY } from 'schema/User/queries';

import { Mention, mapUserObject } from './helpers';

export const useUsersSearch = (
  skipFilterBySpace: boolean = false
): {
  handleSearch: (search: string) => Promise<Mention[]>;
  fetchUsers: (communityId: string) => Promise<Mention[]>;
  fetchMore: Promise<Mention[]>;
} => {
  const { community, spaceId } = useCommunityContext();

  const handleSearch = async (search: string) => {
    const variables = {
      searchTerm: search,
      communityId: community.id,
      ...(!skipFilterBySpace && { spaceId }),
    };

    const res = await fetchMore({ variables });
    return mapUserObject(res?.data?.community?.mentionableUsers?.edges);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const fetchUsers = (communityId: string): any => {
    // Skip the first load of this query, but establish a fetchMore.
    // This is because of useLazyQuery's lack of return
    // https://github.com/apollographql/react-apollo/issues/3499
    // This query will only be called when the fetchMore is used in the handleSearch function
    const { fetchMore } = useQuery(USERS_QUERY, {
      variables: {
        communityId,
        ...(!skipFilterBySpace && { spaceId }),
      },
      notifyOnNetworkStatusChange: true,
      skip: true,
    });

    return fetchMore;
  };

  const fetchMore = fetchUsers(community.id);

  return { handleSearch, fetchUsers, fetchMore };
};
